// extracted by mini-css-extract-plugin
export default {"root":"ParticleBackgroundCanvas_root__D5b8F"};